import React, { useEffect } from 'react';

import useApi from 'common/useApi';
import { useFormContext } from 'react-hook-form';
import SelectInput from 'components/SelectInput';

const Tag = ({ open }: { open: boolean }) => {
  const { isLoading, data, isError } = useApi('get', '/api/workers/available_labels');
  const { setValue } = useFormContext();

  useEffect(() => {
    if(open){
      setValue('label', '');
    }
  }, [open]);

  return (
    <SelectInput
      canEditOption={true}
      placeholder='Type a new label'
      disabled={isLoading || isError}
      options={[
        ...data?.filter((label:string) => '' !== label).map((label: string) => ({
          name: label,
          value: label,
        })) ?? [],
        {
          isDefault: true,
          name: 'Label',
          value: '',
        },
      ]}
      onChange={(value) => {
        setValue('label', value);
      }}
    />
  );
};

export default Tag;
